import { Component, Input } from '@angular/core';

@Component({
    selector   : 'my-tel',
    template: '{{format()}}'
})

export class TelComponent {

    @Input('tel') tel: string;

    constructor() {
    }

    public format() : string{
        if (this.tel.substr(0, 4) == '0041') {
            return '0' + this.tel.substr(4, 2) + ' ' + this.tel.substr(6, 3) + ' ' + this.tel.substr(9, 2) + ' ' + this.tel.substr(11, 2);
        }
        return this.tel;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/tel/tel.component.ts